import * as React from 'react'

import CalendarIcon from '@uniiverse/library/assets/icons/calendar.svg'

const style = require('./event-time.css')

interface Props {
  date: string;
}

export const EventTime: React.FunctionComponent<Props> = ({ date }) => (
  <div className={style.container}>
    <CalendarIcon className={style.icon} />
    <p className={style.text}>{date}</p>
  </div>
)
